export default __webpack_public_path__ + "static/media/bg-polistar.1a44f63d.jpg";